export const BrowserSessionName = 'tokens-browser';
export const BrowserSessionType = 'tokenData';

export const REGISTER_WITH_DIGIPAS = 'mijn-tokens-browser.register-with-digipas';
